/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSourcingBatchesDto
 */
export interface CreateSourcingBatchesDto {
    /**
     * Order IDs whose items should be grouped into supplier batches. Items already in an open batch are skipped.
     * @type {Array<number>}
     * @memberof CreateSourcingBatchesDto
     */
    orderIds: Array<number>;
    /**
     * Optional admin notes carried on every created batch
     * @type {string}
     * @memberof CreateSourcingBatchesDto
     */
    notes?: string;
}

/**
 * Check if a given object implements the CreateSourcingBatchesDto interface.
 */
export function instanceOfCreateSourcingBatchesDto(value: object): value is CreateSourcingBatchesDto {
    if (!('orderIds' in value) || value['orderIds'] === undefined) return false;
    return true;
}

export function CreateSourcingBatchesDtoFromJSON(json: any): CreateSourcingBatchesDto {
    return CreateSourcingBatchesDtoFromJSONTyped(json, false);
}

export function CreateSourcingBatchesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSourcingBatchesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'orderIds': json['orderIds'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CreateSourcingBatchesDtoToJSON(value?: CreateSourcingBatchesDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'orderIds': value['orderIds'],
        'notes': value['notes'],
    };
}

